import { render, staticRenderFns } from "./ChooseGood.vue?vue&type=template&id=ef49c432&scoped=true"
import script from "./ChooseGood.vue?vue&type=script&lang=js"
export * from "./ChooseGood.vue?vue&type=script&lang=js"
import style0 from "./ChooseGood.vue?vue&type=style&index=0&id=ef49c432&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef49c432",
  null
  
)

export default component.exports